import React, { useId } from "react";
import { Box, List } from "@mui/material";

import { SidebarItemsType } from "../../types/sidebar";
import SidebarNavList from "./SidebarNavList";

type SidebarNavSectionProps = {
  pages: SidebarItemsType[];
  title: string;
  collapsed?: boolean;
  onNavigate?: () => void;
};

/** One captioned group of nav items; the caption hides when the sidebar is collapsed. */
const SidebarNavSection: React.FC<SidebarNavSectionProps> = ({
  pages,
  title,
  collapsed = false,
  onNavigate,
}) => {
  const captionId = useId();

  return (
    <Box
      role="group"
      aria-labelledby={collapsed ? undefined : captionId}
      aria-label={collapsed ? title : undefined}
    >
      {collapsed ? (
        <Box aria-hidden sx={{ height: 8 }} />
      ) : (
        <Box
          id={captionId}
          sx={{
            fontSize: "0.65625rem",
            fontWeight: 400,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            color: "text.secondary",
            px: 2.5,
            pt: 2.5,
            pb: 1,
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Box>
      )}
      <List
        disablePadding
        sx={{ display: "grid", gap: 0.5 }}
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          // Only a followed link counts as navigating (not expanding a group).
          if (onNavigate && (event.target as HTMLElement).closest("a")) {
            onNavigate();
          }
        }}
      >
        <SidebarNavList pages={pages} depth={0} collapsed={collapsed} />
      </List>
    </Box>
  );
};

export default SidebarNavSection;
